import React, { useState } from 'react';
import buttonImage from '../buttonimage.webp'; // Import button image
import backgroundImage from '../background.webp'; // Import background image
import cardBackgroundImage from '../cardbackground.webp'; // Import card background image
import mirrorimage from '../mirrorimage.webp';

function Coping({ goBack, goHome, handleSaveProgress }) {
    const [showMoreCard1, setShowMoreCard1] = useState(false);
    const [showMoreCard2, setShowMoreCard2] = useState(false);
    const [showMoreCard3, setShowMoreCard3] = useState(false);
    const [showMoreCard4, setShowMoreCard4] = useState(false);

    const handleSave = async () => {
        if (typeof handleSaveProgress === 'function') {
            await handleSaveProgress('coping', null, false);
            alert('Session progress has been saved successfully!');
        }
    };

    // --- Card 1: Toggle after first 4 paragraphs ---
    const card1Paragraphs = [
        "Are you conscious of your coping strategies? It just means aware.  It means awake. To be conscious is to observe and be. It doesn't mean that we have to know anything.. it just means that we are aware and awake.  What coping are you aware of and awake to?",
        "Does your awareness expand continuously, or are you using coping mechanisms to keep your world small?",
        "With practice we can become awake and aware in more circumstances. Another way to expand our consciousness is to clear the energy loops that are keeping us in reactive responses. The energy loops can filter our view and therefore when we clear them we gain a bigger perspective.",
        "Have you ever noticed yourself reacting to a situation without a decision to do so prior? What kind of results do you get when you react instead of respond? Becoming aware of our own reactive state is the first step in being able to free ourselves from the limitation of automatic reactions.",
        "There are typical ways that humans cope with experiences they have.  There are many experiences that cause humans to look for ways to cope, including unmet needs.  Even before a person is conscious enough to look for a way to cope they are modeled ways of coping by their caregivers and people in ther environment.  Whenever we adopt a way to cope it is possible we will be so practiced at doing it that it falls to our subconsious where we stop noticing that we are doing it.Some of the most common ways that we cope with anything we misunderstand, or are overwhelmed by are Projection, Blame, Denial, Supression, Repression, Compensation, Fabrication and Justification. Whenever we are coping with something it means that thing is not fully in our conscious awareness.  Coping is a way to avoid processing something fully, but it can also be a way to try and recreate the circumstances that will help us get our needs met. Often times when a need goes unmet since childhood the conscious awareness of that need is not there. This means that the ways we are coping are the ways we are being inauthentic.  Let me explain:"
    ];
    const card1Preview = card1Paragraphs.slice(0, 4);
    const card1Rest = card1Paragraphs.slice(4);

    // --- Card 2: Toggle after a specific sentence ---
    const card2Text = `Authenticity: 
In a way it's impossible to be inauthentic, it's just that since some of what we express and live out is due to subconscious patterns, and since those subconscious patterns are often absorbed from our environment and go below the level of our awareness, we may not realize that we are sometimes just acting out programmed responses and coping mechanisms that go against who we really are, and what we would choose for ourselves on the inside, in our hearts. The pressure this creates is felt as uncomfortable.

Authenticity is about living by who we are on the inside instead of living by what we learned on the outside. 
The first step to authenticity can often be sovereignty.  

Sovereignty is a state of knowing yourself as an individual.  It means taking responsibility for meeting our own needs and expressing our own truth.  It means we are not needing validation from others in order to accept and love parts of ourselves. To be authentically ourselves is to be in peace.   Though when we are acting out our programmed responses and coping mechanisms we are also acting authentically, it is a version of ourselves that wears a mask, so to speak. The mask of what we are protecting, or fearing, or programmed to think or do. 
   `;
    const card2ToggleSentence = "The pressure this creates is felt as uncomfortable.";
    const card2ToggleIdx = card2Text.indexOf(card2ToggleSentence) + card2ToggleSentence.length;
    const card2Preview = card2Text.slice(0, card2ToggleIdx);
    const card2Rest = card2Text.slice(card2ToggleIdx);

    // --- Card 3: Toggle after a specific sentence ---
    const card3Text = `Coping mechanisms and methods usually play out automatically.  This is when we notice we react to stimuli instead of responding. Whenever we are reacting we are doing that without our conscious awareness leading the way.  Sometimes we may even notice ourselves reacting in a way we do not prefer or wish we had not done.  This shows how these coping mechanisms play like a recorded response to certain experiences, or feelings.
Projection does not play out that way but it is a very common way of coping with our judgments, losses, and fears.  Whenever we have demonized something in our reality it causes us to repetitively experience it so that we can eventually resolve it.  This strong aversion to something is often placed in the form of blame onto others. This projection is very common.  The other becomes the placeholder for our pain about what we have decided to believe when we demonize others. Another way projection can be used to cope is when we create a situation that will cause someone else to feel what we refuse to feel.  The energy within is will show up in our reality.  Ultimately it is all about us and what is inside us. The outside matches the inside.  
A common coping mechanism used is control.  Some people cope by keeping their world small, always doing the same things, with the same people to ensure there are no suprises and this way they know they can handle what they encounter.  Control is like the control in an experiment.  Everything is kept just so that things are predictable.  Of course this is no guarantee that things will be predictable.  There is a likelihood that controlling things in our lives will eventually be proven as futile, especially when other people are involved.  Still this way of coping is often praciticed by those who have not yet learned to regulate themselves in the unknown.  Here is what I noticed about the energy of control. 
When we try to control something we are introducing FORCE and while sometimes we can effect change with force it will usually have some other Ill effect. ENERGY does not respond well to force. Instead, we set our intention, which is like an INTRODUCTION to the energy.. "Hi Energy(thing I used to control), how's about we go this way." If we pay attention we will see everything in the way of the energy going that way and have opportunity to clear each detractor. 
When we clear the contrary energy which can often be harbored in our own subconscious, the energy moves in the direction we intend. It is a Co-creation. Energy responds to the introduction we make to it..while the force we impede on it can have a backfire or unintended consequences. Energy likes to flow, is moving, will show up in response to us, and is us.`;
    const card3ToggleSentence = "Ultimately it is all about us and what is inside us. The outside matches the inside.";
    const card3ToggleIdx = card3Text.indexOf(card3ToggleSentence) + card3ToggleSentence.length;
    const card3Preview = card3Text.slice(0, card3ToggleIdx);
    const card3Rest = card3Text.slice(card3ToggleIdx);

    // --- Card 4: Toggle after a specific sentence ---
    const card4Text = `Coping in Relationships - There are certain habits we adopt to survive or fit into our family dynamics growing up.  A lot of these get pushed into our subconscious where we are not aware of them.  We get to see ourselves when we reflect on how we are acting or feeling and especially in the ways we relate to others. What is normal for one person can seem off to another.  
So, after I knew what my values were I found it beneficial to always be aware of myself and how I was in relation to others.  Knowing that everything I think, feel and perceive is directly related to what is inside me allows me to heal anything that would keep me out of integrity because it does not meet my own values.  It is what we believe we should be that matters, not what others think we should be. 
Authenticity is the highest vibration. so, being true to ourselves and what is important to us is what matters here.  This is not about being perfect or a cookie cutter copy of the next person.  Our values can also change and we change too.
Some examples of ways we can look back at ourselves based on how we we relate to others are things like: 
If you can't hear someone talk about themselves.. you may have disallowed yourself to talk about yourself..
If you can't hear someone complain. You may have disallowed yourself to complain.
If you can't listen to someone's uncomfortable experience, you may have never had anyone listen to your uncomfortable experience.
There is a common relating dynamic that surfaces often in families where alcoholism, or cluster B traits are present in a family member.  This has been referred to as the "drama triangle". Here is how it functions:
There are three positions on the field so to speak and the people will choose a position to relate from and may switch up their position to another of the other two at any time.  Victim, Rescuer, and Persecutor.  So, the rescuer helps the victim, but they don't help the way the victim wants the help so now the victim becomes the persecutor complaining or blaming the rescuer for not giving the right kind of help and now the rescuer has become the victim. 
It can also play out that the rescuer helps the victim and then the rescuer doesn't think the victim appreciated the help enough so they get mad and turn into the persecuter complaining and blaming the victim.  On different topics people will play different roles but you can see how someone is always getting blamed and or shamed and someone is always the victim.
There are layered reasons why these roles work for each of these people.  The role of the rescuer is often played by someone who is comfortable giving but may not allow themselves to recieve.  The victim role may be played by someone who only gets the love and attention they need when they are in trouble or need something, they may not feel capable of taking responsibility or know how.  The persecutor is played by anyone who is trying to cope with regulating themselves by expecting others to stay in the role they are in, either giving appreciation, or getting the help in a way that fulfills them and does not let them feel their lack of ability to do it for themselves. 
This pattern of relating is very surface level and can feel very normal in families where it happens.  It may not feel like a big deal because often times disagreements between people happen with an eruption and then it is all pushed "under the rug" when another cycle of the triangle begins with someone needing something again. 
When we have grown up with this relating dynamic present we may recreate that repeatedly in our relationships with others.  Even when we become aware of this there can be layers of it that surface over time to heal in ourselves/>`;

    // Choose a reasonable split point for the preview (e.g., after the first 4 paragraphs)
    const card4Paragraphs = card4Text.split('\n');
    const card4Preview = card4Paragraphs.slice(0, 4).join('\n');
    const card4Rest = card4Paragraphs.slice(4).join('\n');

    // Show only the first 4 paragraphs by default (handled above)
    // (Removed duplicate card1Preview and card1Rest)

    return (
        <div style={{
            backgroundImage: `url(${backgroundImage})`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '16px',
        }}>
            {/* Title */}
            <h3 style={{
                fontFamily: 'Times New Roman, Times, serif',
                fontSize: '24px',
                fontWeight: 'bold',
                color: 'black',
                marginBottom: '32px',
            }}>
                Coping
            </h3>

            {/* Mirror Image Card */}
            <div
                style={{
                    width: '100%',
                    maxWidth: '600px',
                    borderRadius: '10px',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    border: '2px solid black',
                    marginBottom: '24px',
                    marginTop: 0,
                    overflow: 'hidden',
                    background: 'transparent',
                }}
            >
                <img
                    src={mirrorimage}
                    alt="Mirror"
                    style={{
                        width: '100%',
                        borderRadius: '10px 10px 0 0',
                        objectFit: 'cover',
                        maxHeight: '220px',
                    }}
                />
                <div
                    style={{
                        backgroundImage: `url(${cardBackgroundImage})`,
                        backgroundSize: 'cover',
                        borderBottomLeftRadius: '10px',
                        borderBottomRightRadius: '10px',
                        padding: '24px',
                        textAlign: 'center',
                    }}
                >
                    <div style={{
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '22px',
                        fontWeight: 'bold',
                        color: '#4B5563',
                        margin: '0 0 8px 0',
                        textAlign: 'center',
                    }}>
                        Coping
                    </div>
                    <div style={{
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '16px',
                        color: '#333',
                        textAlign: 'center',
                    }}>
                        Coping is what we do when something isn't right
                    </div>
                </div>
            </div>

            {/* Session Helper Cards Row */}
            <div
                className="coping-session-helper-row"
                style={{
                    display: 'flex',
                    flexDirection: window.innerWidth <= 600 ? 'column' : 'row',
                    gap: '16px',
                    width: '100%',
                    maxWidth: '600px',
                    marginBottom: '16px',
                }}
            >
                {/* Left Card */}
                <div style={{
                    flex: 1,
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    textAlign: 'left',
                    backgroundImage: `url(${cardBackgroundImage})`,
                    backgroundSize: 'cover',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    marginBottom: window.innerWidth <= 600 ? '16px' : 0,
                }}>
                    <div style={{ fontFamily: 'Times New Roman, Times, serif', fontWeight: 'bold', fontSize: '18px', marginBottom: '10px', textAlign: 'center' }}>*Session Helper*</div>
                    <div style={{ fontFamily: 'Times New Roman, Times, serif', fontWeight: 'bold', fontSize: '16px', margin: 0 }}>
                        <div>• Coping is a way we take care of ourselves. We need our coping methods.</div>
                        <div>• It is not wrong to cope, but it is good to become aware of our coping when it is hindering us and is ready to be seen.</div>
                        <div>• Any time we are justifying something we are doing that to protect ourselves or our perspective.</div>
                        <div>• When we are able to process our experiences and meet our own needs we do not need to cope any longer.</div>
                        <div>• Projection is a way to find a placeholder for our unprocessed energy until we are able to process it. </div>
                        <div>• Blame may be accurate but energetically it prohibits us from our self reflection.</div>
                    </div>
                </div>
                {/* Right Card */}
                <div style={{
                    flex: 1,
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    textAlign: 'left',
                    backgroundImage: `url(${cardBackgroundImage})`,
                    backgroundSize: 'cover',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                }}>
                    <div style={{ fontFamily: 'Times New Roman, Times, serif', fontWeight: 'bold', fontSize: '18px', marginBottom: '10px', textAlign: 'center' }}>*Session Helper*</div>
                    <div style={{ fontFamily: 'Times New Roman, Times, serif', fontWeight: 'bold', fontSize: '16px', margin: 0 }}>
                        <div>1. Can you think of ways that you may be living against how you really want to live?</div>
                        <div>2. Are there circumstances where you hold back your true expression?</div>
                        <div>3. Is there anyone else who really knows you? How well do you feel you know yourself?</div>
                        <div>4. Is there anywhere you are being a hero/persecutor/victim?</div>
                        <div>5. Have you noticed yourself responding in ways that you prefer not to?</div>
                        <div>6. How do you cope with your unmet needs?</div>
                    </div>
                </div>
            </div>

            {/* Cards */}
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '16px',
                width: '100%',
                maxWidth: '600px',
            }}>
                {/* Card 1 with see more/see less */}
                <div style={{
                    width: '100%',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    textAlign: 'center',
                    backgroundImage: `url(${cardBackgroundImage})`,
                    backgroundSize: 'cover',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                }}>
                    {(!showMoreCard1 ? card1Preview : card1Paragraphs).map((para, idx) => (
                        <p key={idx} style={{
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            color: 'black',
                            marginBottom: '8px'
                        }}>{para}</p>
                    ))}
                    {card1Rest.length > 0 && (
                        <button
                            style={{
                                background: 'none',
                                border: 'none',
                                color: '#007AFF',
                                fontWeight: 'bold',
                                cursor: 'pointer',
                                fontSize: '15px',
                                marginTop: '0'
                            }}
                            onClick={() => setShowMoreCard1(v => !v)}
                        >
                            {showMoreCard1 ? 'See less' : 'See more'}
                        </button>
                    )}
                </div>

                {/* Card 2 with see more/see less */}
                <div style={{
                    width: '100%',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    textAlign: 'center',
                    backgroundImage: `url(${cardBackgroundImage})`,
                    backgroundSize: 'cover',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                }}>
                    <p style={{
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '16px',
                        color: 'black',
                        whiteSpace: 'pre-line',
                        marginBottom: '0'
                    }}>
                        {showMoreCard2 ? card2Text : card2Preview}
                    </p>
                    {card2Rest.trim() && (
                        <button
                            style={{
                                background: 'none',
                                border: 'none',
                                color: '#007AFF',
                                fontWeight: 'bold',
                                cursor: 'pointer',
                                fontSize: '15px',
                                marginTop: '0'
                            }}
                            onClick={() => setShowMoreCard2(v => !v)}
                        >
                            {showMoreCard2 ? 'See less' : 'See more'}
                        </button>
                    )}
                </div>

                {/* Card 3 with see more/see less */}
                <div style={{
                    width: '100%',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    textAlign: 'center',
                    backgroundImage: `url(${cardBackgroundImage})`,
                    backgroundSize: 'cover',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                }}>
                    <p style={{
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '16px',
                        color: 'black',
                        whiteSpace: 'pre-line',
                        marginBottom: '0'
                    }}>
                        {showMoreCard3 ? card3Text : card3Preview}
                    </p>
                    {card3Rest.trim() && (
                        <button
                            style={{
                                background: 'none',
                                border: 'none',
                                color: '#007AFF',
                                fontWeight: 'bold',
                                cursor: 'pointer',
                                fontSize: '15px',
                                marginTop: '0'
                            }}
                            onClick={() => setShowMoreCard3(v => !v)}
                        >
                            {showMoreCard3 ? 'See less' : 'See more'}
                        </button>
                    )}
                </div>

                {/* Card 4 - new sample card with see more/see less */}
                <div style={{
                    width: '100%',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    textAlign: 'center',
                    backgroundImage: `url(${cardBackgroundImage})`,
                    backgroundSize: 'cover',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                }}>
                    <p style={{
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '16px',
                        color: 'black',
                        whiteSpace: 'pre-line',
                        marginBottom: '0'
                    }}>
                        {showMoreCard4 ? card4Text : card4Preview}
                    </p>
                    {card4Rest.trim() && (
                        <button
                            style={{
                                background: 'none',
                                border: 'none',
                                color: '#007AFF',
                                fontWeight: 'bold',
                                cursor: 'pointer',
                                fontSize: '15px',
                                marginTop: '0'
                            }}
                            onClick={() => setShowMoreCard4(v => !v)}
                        >
                            {showMoreCard4 ? 'See less' : 'See more'}
                        </button>
                    )}
                </div>
            </div>

            {/* Navigation Buttons */}
            <div
                className="coping-nav-btn-row"
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '16px',
                    marginTop: '32px',
                    marginBottom: '16px',
                }}
            >
                <button style={{
                    backgroundImage: `url(${buttonImage})`,
                    backgroundSize: 'cover',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '10px 20px',
                    width: '120px',
                    fontFamily: 'Times New Roman, Times, serif',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                }} onClick={goBack}>Back</button>
                <button style={{
                    backgroundImage: `url(${buttonImage})`,
                    backgroundSize: 'cover',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '10px 20px',
                    width: '120px',
                    fontFamily: 'Times New Roman, Times, serif',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                }} onClick={goHome}>Home</button>
                <button style={{
                    backgroundImage: `url(${buttonImage})`,
                    backgroundSize: 'cover',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '10px 20px',
                    width: '120px',
                    fontFamily: 'Times New Roman, Times, serif',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                }} onClick={handleSave}>Save</button>
            </div>
            <style>
                {`
                @media (max-width: 600px) {
                    .coping-nav-btn-row {
                        position: static !important;
                        width: 100%;
                        background: none;
                        border-top: none;
                        border-radius: 0;
                        box-shadow: none;
                        padding: 0;
                        z-index: auto;
                        display: flex;
                        justify-content: center;
                        gap: 10px;
                        margin-top: 32px !important;
                        margin-bottom: 16px !important;
                    }
                    body {
                        padding-bottom: 0 !important;
                    }
                }
                `}
            </style>
        </div>
    );
}

export default Coping;
